export default [
  {
    id: "shopping",
    title: "一、商城购物",
    sections: [
      {
        id: "1-1",
        title: "1.1 售前-咨询",
        items: [
          {
            q: "如何挑选商品?",
            a:
              "1、点击首页最上方搜索框，输入关键字进行搜索；\n2、应用首页向下滑动，我们将给您推荐优质商品；\n3、点击“分类”页面，根据商品分类挑选商品。"
          },
          {
            q: "如何查看购物车？",
            a:
              "1、打开迅速购物，点击底部购物；\n2、打开迅速购物，进入商品详情，点击页面下方购物车按钮。"
          },
          {
            q: "如何下单？",
            a:
              "登录迅速购物-->搜索或选择心仪的商品-->点击“立即购物”进入确认订单页面-->选择收货地址-->选择“优惠券”-->点击“提交订单”-->选择第三方支付方式-->按照提示支付即可。"
          },
          {
            q: "如何修改收货地址？",
            a:
              "登录迅速购物-->搜索或选择心仪的商品-->点击“立即购物”进入确认订单页面-->点击“请添加收货地址信息”-->点击“添加”或“添加新收货地址”-->输入收货人、手机号码、地址-->点击保存，即可填写成功。"
          },
          {
            q: "如何填写收货地址？",
            a:
              "登录迅速购物-->搜索或选择心仪的商品-->点击“立即购物”进入确认订单页面-->点击“请添加收货地址信息”-->点击“编辑”-->输入收货人、手机号码、地址-->点击保存，即可修改成功。"
          }
        ]
      },
      {
        id: "1-2",
        title: "1.2 售中-订单",
        items: [
          {
            q: "如何查询订单信息？",
            a:
              "登录迅速购物-->点击“我的”-->点击“全部订单”-->选择并点击需要查看的订单，即可查看订单信息。"
          },
          {
            q: "如何查询收货人信息？",
            a:
              "登录迅速购物-->点击“我的”-->点击“全部订单”-->选择并点击需要查看的订单，即可查看收货人信息。"
          },
          {
            q: "订单需要确认收货吗？",
            a: "您已经确认收到商品，请您登录迅速购物，在订单中点击确认收货。"
          },
          {
            q: "如何操作确认收货？",
            a:
              "登录迅速购物-->点击“我的”-->点击“全部订单”-->选择并点击需要查看的订单-->点击“确认收货”-->再点击“确认”即可确认收货。"
          }
        ]
      },
      {
        id: "1-3",
        title: "1.3 售中-物流",
        items: [
          {
            q: "发货了，如何修改收货人信息？",
            a:
              "订单已经发货后，无法修改收货人信息。如您信息错误无法收货，建议您联系快递公司拒收后重新购买。"
          },
          {
            q: "发货了，如何修改订单信息？",
            a:
              "订单已经发货后，无法修改收货人信息。如您信息错误无法收货，建议您联系快递公司拒收后重新购买。"
          },
          {
            q: "发货了，如何取消订单？",
            a:
              "订单已经发货后，如您确认商品不需要了，可以联系快递公司拒收。同时登录迅速购物，申请退款并选择“我要退款（无需退货）”，待商品退回后，仓库会进行退款，还请您耐心等待~"
          },
          {
            q: "商品少发了，怎么办？",
            a:
              "一个订单购买多个商品可能会分为一个以上包裹发出，可能不会同时送达，建议您耐心等待1-2天，如未收到，请您直接联系客服。"
          },
          {
            q: "商品发错了，怎么办？",
            a:
              "您确认收到的商品不是您订单中订购的商品，请在签收24小时内拍照并发送给客服，提交成功后请耐心等待，由专业的售后工作人员受理您的申请。"
          }
        ]
      },
      {
        id: "1-4",
        title: "1.4 售后-退换货",
        items: [
          {
            q: "如何申请退/换货？",
            a:
              "登录迅速购物-->点击“我的”-->点击“全部订单”-->选择并点击需要查看的订单-->点击“申请售后”-->选择“我要退货退款”-->选择货物状态和退货原因后，点击提交后等待系统审核；如有疑问，请及时联系客服~"
          },
          {
            q: "为何无法申请售后？",
            a:
              "订单无法申请售后服务可能有以下几种情况：\n1、订单已超出售后申请时间；\n2、订单中商品暂不支持售后申请。"
          },
          {
            q: "怎么查看退/换货进度？",
            a:
              "您可以登录迅速购物查看售后进度，具体查看方法：登录迅速购物-->点击“我的”-->点击“退款/售后”-->点击“查看详情”，即可查询售后进度。"
          },
          {
            q: "退货要多久？",
            a:
              "一般情况下，退货处理周期（不包含检测时间）如下：\n退货：自接收到问题商品日期起7日之内处理完成；\n换货：自接收到问题商品之日起7日之内处理完成；\n该周期的起始时间以售后登记到货品之日起算，需要检测的商品时间会相应延长7-15天。国家法定节假日会相应延长。"
          },
          {
            q: "换货要多久？",
            a:
              "一般情况下，换货处理周期（不包含检测时间）如下：\n退货：自接收到问题商品日期起7日之内处理完成；\n换货：自接收到问题商品之日起7日之内处理完成；\n该周期的起始时间以售后登记到货品之日起算，需要检测的商品时间会相应延长7-15天。国家法定节假日会相应延长。"
          }
        ]
      }
    ]
  },
  {
    id: "account",
    title: "二、账户问题",
    sections: [
      {
        id: "2-1",
        title: "2.1 用户登录、用户注册、重置密码",
        items: [
          {
            q: "提示密码错误怎么办？",
            a:
              "您可以先查看密码输入是否正确；如果仍无法登录可以选用快捷登录的方式。"
          },
          {
            q: "如何注册迅速购物？",
            a: "打开迅速购物，输入您的手机号进行注册。"
          },
          {
            q: "是否可以换其他手机号登录？",
            a: "不可以更换其他手机号登录。需使用新手机号重新注册。"
          },
          {
            q: "设置密码是否有限制？",
            a: "密码限制为6-16位字母和数字的组合。"
          },
          {
            q: "如果不使用，能注销账户么？",
            a:
              "若不存在未完结订单或售后或其他费用时，支持主动注销账户，我的-设置-注销账户。"
          }
        ]
      },
      {
        id: "2-2",
        title: "2.2 修改信息",
        items: [
          {
            q: "申请的时候信息填写错了，可以修改么？",
            a:
              "为了保证用户的信息安全，具体修改方式和条件，请联系迅速购物客服。"
          },
          {
            q: "我注册的手机号码注销了，可以更改吗？",
            a:
              "很抱歉，为了用户的信息安全，目前不支持更改注册手机号。"
          },
          {
            q: "我的名字填写错误，是否可以更改？",
            a:
              "为了保证用户的信息安全，如需修改信息，请联系迅速购物客服。"
          }
        ]
      }
    ]
  },
  {
    id: "other",
    title: "三、其他问题",
    sections: [
      {
        id: "3-1",
        title: "3.1 咨询类",
        items: [
          {
            q: "如何联系客服？",
            a:
              "登录迅速购物，可以通过“我的-添加客服”或者“我的-联系客服”来与我们取得联系。"
          },
          {
            q: "商务合作如何联系你们？",
            a:
              "您好，您可以将您的信息及合作内容，邮件发送至zushoping@163.com，如有需要我们会及时和您取得联系。"
          }
        ]
      }
    ]
  }
];
